"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const IRViewerKeys = Object.freeze({
    ANNOTATIONS: "ANNOTATIONS",
    GLOBAL_MARKER_VISIBLE: "globalMarkerVisible",
    STATUS: "status",
    REFERENCE_MARKER_ID: "referenceMarkerId",
    ASSET_TAG: "assetTagId"
});
const _default = IRViewerKeys;
